var headerSwiper = new Swiper(".headerSwiper", {
	loop: true,
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
});

var hs2Swiper = new Swiper(".hs2Swiper", {
	loop: true,
	navigation: {
		nextEl: ".hs2-button-next",
		prevEl: ".hs2-button-prev",
	},
	breakpoints: {
		576: {
			slidesPerView: 1,
			spaceBetween: 0,
		},
		768: {
			slidesPerView: 1.25,
			spaceBetween: 10,
		},
		992: {
			slidesPerView: 1.5,
			spaceBetween: 20,
		},
		1200: {
			slidesPerView: 1.75,
			spaceBetween: 30,
		},
	},
});

var hs2mSwiper = new Swiper(".hs2mSwiper", {
	loop: true,
	slidesPerView: 1,
	navigation: {
		nextEl: ".hs2m-button-next",
		prevEl: ".hs2m-button-prev",
	},
});

var ZonesSwiper = new Swiper(".ZonesSwiper", {
	loop: true,
	slidesPerView: 1.5,
	spaceBetween: 30,
	navigation: {
		nextEl: ".z1-button-next",
		prevEl: ".z1-button-prev",
	},
	breakpoints: {
		576: {
			slidesPerView: 1,
			spaceBetween: 0,
		},
		768: {
			slidesPerView: 1.5,
			spaceBetween: 10,
		},
		992: {
			slidesPerView: 1.75,
			spaceBetween: 20,
		},
		1200: {
			slidesPerView: 2.5,
			spaceBetween: 30,
		},
	},
});

var ZonesSwiperM = new Swiper(".ZonesSwiperM", {
	loop: true,
	slidesPerView: 1,
	navigation: {
		nextEl: ".z1m-button-next",
		prevEl: ".z1m-button-prev",
	},
});
var ActivitiesSwiper = new Swiper(".ActivitiesSwiper", {
	loop: true,
	slidesPerView: "auto",
	spaceBetween: 8,
	navigation: {
		nextEl: ".a3-button-next",
		prevEl: ".a3-button-prev",
	},
	breakpoints: {
		576: {
			slidesPerView: 1,
			spaceBetween: 0,
		},
		768: {
			slidesPerView: 1,
			spaceBetween: 0,
		},
		992: {
			slidesPerView: 2,
			spaceBetween: 10,
		},
		1200: {
			slidesPerView: 3,
			spaceBetween: 10,
		},
	},
});

var ActivitiesSwiperM = new Swiper(".ActivitiesSwiperM", {
	loop: true,
	centeredSlides: true,
	spaceBetween: 30,
	navigation: {
		nextEl: ".a3m-button-next",
		prevEl: ".a3m-button-prev",
	},
});

var PricesSwiper = new Swiper(".PricesSwiper", {
	loop: true,
	navigation: {
		nextEl: ".p3-button-next",
		prevEl: ".p3-button-prev",
	},
	breakpoints: {
		576: {
			slidesPerView: 1,
			spaceBetween: 0,
		},
		768: {
			slidesPerView: 1.25,
			spaceBetween: 10,
		},
		992: {
			slidesPerView: 1.5,
			spaceBetween: 10,
		},
		1200: {
			slidesPerView: 2.25,
			spaceBetween: 10,
		},
	},
});

var PricesSwiperM = new Swiper(".PricesSwiperM", {
	loop: true,
	slidesPerView: 1,
	spaceBetween: 0,
	navigation: {
		nextEl: ".p3m-button-next",
		prevEl: ".p3m-button-prev",
	},
});
